<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M9.333 5v4.012a2.333 2.333 0 002.334 2.333H20a2.333 2.333 0 002.333-2.333v-3.93l.017.015 4.552 4.552a.333.333 0 01.098.236v16.78c0 .185-.15.334-.333.334H23.5v-7a2.333 2.333 0 00-2.333-2.333h-10.5a2.333 2.333 0 00-2.334 2.333v7h-3A.333.333 0 015 26.666V5.333c0-.185.15-.334.333-.334h4zm1 22H21.5v-7a.333.333 0 00-.333-.334h-10.5a.333.333 0 00-.334.333v7zm-5 2A2.333 2.333 0 013 26.665V5.333a2.333 2.333 0 012.333-2.334h16l1-.001v.011a2.331 2.331 0 011.431.674l4.553 4.552c.437.437.683 1.031.683 1.65v16.78A2.333 2.333 0 0126.667 29H5.333zm6-23.99v4.002c0 .184.15.333.334.333H20c.184 0 .333-.15.333-.333V5l-9 .01z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsFloppyDiskOutline'
}
</script>
